import { compose } from "redux";
import { IAction } from "../../../models/Action";
import {
  IBREntitlementsItem,
  IBRRequestItem,
  IEntitlementItem,
} from "../../../models/Entitlements";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const ACTION_HANDLERS = {
  [actionTypes.MODIFY_SELECTED_USER]: (state: any, action: any) =>
    immutableSet(["selectedUser"], action.user, state),

  [actionTypes.USERS_REQUEST]: (state: any, action: any) =>
    immutableSet(["usersLoader"], true, state),
  [actionTypes.USERS_REQUEST_SUCCESS]: (state: any, action: any) => {
    const payloadTemp = action.payload.map((user: any) => {
      return {
        ...user,
        identitySystemId:
          IDENTITY_SYSTEM[
            user.identitySystemId as keyof typeof IDENTITY_SYSTEM
          ],
      };
    });
    payloadTemp &&
      payloadTemp.length > 0 &&
      payloadTemp.map((res: any) =>
        res.delegator ? delete res.delegator : res
      );

    return compose(
      immutableSet(["users"], payloadTemp),
      immutableSet(["usersLoader"], false)
    )(state);
  },
  [actionTypes.USERS_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet(["users"], action.payload),
      immutableSet(["usersLoader"], false)
    )(state),

  [actionTypes.USERS_ACCOUNT_REQUEST]: (state: any, action: any) =>
    immutableSet(["usersManaged", "loader"], true, state),

  [actionTypes.USERS_ACCOUNT_REQUEST_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          id: data.id,
          code: data.code,
          stato: data.status,
          application_name: data.pwdcfg_name,
          forceChangePwd: data.forceChangePwd ? "Yes" : "No",
          lastChangePwd: data.lastChangePwd
            ? new Date(data.lastChangePwd).toLocaleString()
            : "",
          numberLoginError: data.numberLoginError,
          identitySystemId:
            IDENTITY_SYSTEM[
              data.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(["usersManaged", "list"], mappedResponse),
      immutableSet(["usersManaged", "loader"], false)
    )(state);
  },
  [actionTypes.USERS_ACCOUNT_REQUEST_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet(["usersManaged", "list"], action.payload),
      immutableSet(["usersManaged", "loader"], false)
    )(state);
  },

  [actionTypes.USERS_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const {
      entitlements,
      businessRoles,
    }: { entitlements: IEntitlementItem[]; businessRoles: IBRRequestItem[] } =
      action.payload;
    const tempListItems: IEntitlementItem[] = [];
    if (entitlements.length > 0) {
      entitlements
        .filter((entitlement: any) => entitlement.showOnFrontend)
        .forEach((entitlement) => {
          tempListItems.push({
            application_id: entitlement.application_id,
            application_name: entitlement.application_name,
            application_description: entitlement.application_description,
            entitlement_id: entitlement.entitlement_id,
            entitlement_name: entitlement.entitlement_name,
            entitlement_description: entitlement.entitlement_description,
            editable: entitlement.editable,
            identitySystemId:
              IDENTITY_SYSTEM[
                entitlement.identity_system_id! as keyof typeof IDENTITY_SYSTEM
              ],
            chainEntitlementsIds: entitlement.chainEntitlementsIds || [],
            violationOfVisibility: entitlement.violationOfVisibility,
          });
        });
    }
    if (businessRoles.length > 0) {
      businessRoles.forEach((br) => {
        tempListItems.push({
          application_description: br.description,
          application_name: br.name,
          entitlement_description: "",
          entitlement_name: "",
          entitlement_id: br.id,
          application_id: br.id,
          editable: br.editable,
          entitlements: br.entitlements,
          isBR: true,
          identity_system_id: "",
          chainEntitlementsIds: [],
        });
      });
    }

    return immutableSet(["userEntitlements"], tempListItems, state);
  },

  [actionTypes.USERS_ENTITLEMENT_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(["userEntitlements"], action.payload, state),
  [actionTypes.SET_ENTITLEMENTS_BR_SELECTED]: (state: any, action: any) => {
    const payloadTemp: IEntitlementItem = action.payload.map(
      (el: IBREntitlementsItem) => {
        return {
          application_id: el.id,
          application_name: el.applicationName,
          application_description: el.applicationDescription,
          entitlement_name: el.entitlementName,
          entitlement_description: el.entitlementDescription,
          identitySystemId:
            IDENTITY_SYSTEM[el.identitySystem as keyof typeof IDENTITY_SYSTEM],
        } as IEntitlementItem;
      }
    );
    return immutableSet(["entitlementsOfBR"], payloadTemp, state);
  },

  [actionTypes.GET_USER_MANAGERS_SUCCESS]: (state: any, action: any) => {
    const mappedRes: any[] = [];

    if (action.payload && action.payload.length > 0) {
      action.payload.forEach((mg: any) => {
        const temp = {
          code: mg.managerCode,
          ouDescription: mg.ouDescription,
          resp_full_name: mg.managerFullName,
          identitySystemId:
            IDENTITY_SYSTEM[mg.identitySystem as keyof typeof IDENTITY_SYSTEM],
        };
        mappedRes.push(temp);
      });
    }
    return immutableSet(["userManagers"], mappedRes, state);
  },
  [actionTypes.GET_USER_MANAGERS_FAILURE]: (state: any, action: any) =>
    immutableSet(["userManagers"], [], state),
  [actionTypes.GET_USER_OUS_SUCCESS]: (state: any, action: any) => {
    const mappedRes: any = [];
    action.payload.forEach((ou: any) => {
      const temp = {
        id: ou.code,
        name: ou.name,
        description: ou.description,
        owner: ou.ownerFullName,
        identitySystemId:
          IDENTITY_SYSTEM[ou.identitySystem as keyof typeof IDENTITY_SYSTEM],
      };
      mappedRes.push(temp);
    });
    return immutableSet(["userOus"], mappedRes, state);
  },
  [actionTypes.GET_USER_OUS_FAILURE]: (state: any, action: any) =>
    immutableSet(["userOus"], [], state),
  [actionTypes.USER_RESET_STATE]: (state: any, action: any) => emptyState,
  [actionTypes.ENTITLEMENTS_BR_SELECTED_RESET]: (state: any, action: any) =>
    immutableSet(["entitlementsOfBR"], [], state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
